import CustomInstall from './components/tools/CustomInstall.vue';
import WifiSetupTool from './components/tools/WifiSetupTool.vue';
import ToolSelectionView from './views/home/toolbox/ToolSelectionView.vue';
import HomeView from '@/views/HomeView.vue';
import AdminView from '@/views/home/AdminView.vue';
import InstallerView from '@/views/home/InstallerView.vue';
import OrdersView from '@/views/home/OrdersView.vue';
import ToolboxView from '@/views/home/ToolboxView.vue';
import { authGuard } from '@auth0/auth0-vue';
import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    component: HomeView,
    beforeEnter: authGuard,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '',
        redirect: 'orders',
      },
      {
        path: 'orders',
        component: OrdersView,
      },
      {
        path: 'admin',
        component: AdminView,
      },
      {
        path: 'install/:id',
        component: InstallerView,
      },
      {
        path: 'toolbox',
        component: ToolboxView,
        children: [
          {
            path: '',
            component: ToolSelectionView,
          },
          {
            path: 'config-wifi-code',
            component: WifiSetupTool,
          },
          {
            path: 'custom-install',
            component: CustomInstall,
          },
        ],
      },
    ],
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});
